import type { FC } from 'react';
import { useEffect } from 'react';

import { useLocation } from '@xing-com/crate-core-router';

export const ScrollToTop: FC = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
};
